/**
 * Resources Data Configuration
 * 
 * Downloadable resources for Conectados game activities.
 * Preview images are imported locally, while large files (.ppsx) are hosted externally.
 */

import { IoDice } from 'react-icons/io5';

// Import preview images
import aBuenEntendedorPreview from './images/a-buen-entendedor-4-palabras.jpg';
import descubreHimnoPreview from './images/descubre-el-himno-con-el-versiculo.jpg';
import charadasPreview from './images/charadas-biblicas.jpg';
import cualProfesionPreview from './images/cual-es-mi-profesion.jpg';
import descubrePersonajePreview from './images/descubre-el-nombre-del-personaje-biblico.jpg';
import escuchaDescubrePreview from './images/escucha-y-descubre.jpg';
import jeopardyPreview from './images/jeopardy-biblico.jpg';
import organizaVersiculoPreview from './images/organiza-el-versiculo.jpg';
import personajesEmojisPreview from './images/personajes-con-emojis.jpg';
import quienSoyPreview from './images/quien-soy.jpg';

export const recursos = [
  {
    id: 'a-buen-entendedor-4-palabras',
    title: 'A Buen Entendedor, 4 Palabras',
    description: 'Actividad dinámica donde los participantes deben adivinar conceptos usando solo 4 palabras clave.',
    previewImage: aBuenEntendedorPreview,
    fileUrl: 'https://www.feenjuego.com/recursos/a-buen-entendedor-4-palabras.ppsx',
    fileName: 'A-Buen-Entendedor-4-Palabras.ppsx',
    icon: IoDice,
  },
  {
    id: 'descubre-el-himno-con-el-versiculo',
    title: 'Descubre el Himno con el Versículo',
    description: 'Juego musical que conecta versículos bíblicos con himnos conocidos.',
    previewImage: descubreHimnoPreview,
    fileUrl: 'https://www.feenjuego.com/recursos/descubre-el-himno-con-el-versiculo.ppsx',
    fileName: 'Descubre-el-Himno-con-el-Versiculo.ppsx',
    icon: IoDice,
  },
  {
    id: 'charadas-biblicas',
    title: 'Charadas Bíblicas',
    description: 'Divertidas charadas basadas en historias y personajes de la Biblia.',
    previewImage: charadasPreview,
    fileUrl: 'https://www.feenjuego.com/recursos/charadas-biblicas.ppsx',
    fileName: 'Charadas-Biblicas.ppsx',
    icon: IoDice,
  },
  {
    id: 'cual-es-mi-profesion',
    title: '¿Cuál es mi Profesión?',
    description: 'Actividad para descubrir las profesiones y oficios de los personajes bíblicos.',
    previewImage: cualProfesionPreview,
    fileUrl: 'https://www.feenjuego.com/recursos/cual-es-mi-profesion.ppsx',
    fileName: 'Cual-es-mi-Profesion.ppsx',
    icon: IoDice,
  },
  {
    id: 'descubre-el-nombre-del-personaje-biblico',
    title: 'Descubre el Nombre del Personaje Bíblico',
    description: 'Juego de pistas para identificar personajes importantes de la Biblia.',
    previewImage: descubrePersonajePreview,
    fileUrl: 'https://www.feenjuego.com/recursos/descubre-el-nombre-del-personaje-biblico.ppsx',
    fileName: 'Descubre-el-Nombre-del-Personaje-Biblico.ppsx',
    icon: IoDice,
  },
  {
    id: 'escucha-y-descubre',
    title: 'Escucha y Descubre',
    description: 'Actividad auditiva para descubrir mensajes y enseñanzas bíblicas.',
    previewImage: escuchaDescubrePreview,
    fileUrl: 'https://www.feenjuego.com/recursos/escucha-y-descubre.ppsx',
    fileName: 'Escucha-y-Descubre.ppsx',
    icon: IoDice,
  },
  {
    id: 'jeopardy-biblico',
    title: 'Jeopardy Bíblico',
    description: 'Juego tipo Jeopardy con preguntas y desafíos sobre conocimiento bíblico.',
    previewImage: jeopardyPreview,
    fileUrl: 'https://www.feenjuego.com/recursos/jeopardy-biblico.ppsx',
    fileName: 'Jeopardy-Biblico.ppsx',
    icon: IoDice,
  },
  {
    id: 'organiza-el-versiculo',
    title: 'Organiza el Versículo',
    description: 'Desafío para ordenar correctamente las palabras de versículos bíblicos.',
    previewImage: organizaVersiculoPreview,
    fileUrl: 'https://www.feenjuego.com/recursos/organiza-el-versiculo.ppsx',
    fileName: 'Organiza-el-Versiculo.ppsx',
    icon: IoDice,
  },
  {
    id: 'personajes-con-emojis',
    title: 'Personajes con Emojis',
    description: 'Divertida actividad para identificar personajes bíblicos representados con emojis.',
    previewImage: personajesEmojisPreview,
    fileUrl: 'https://www.feenjuego.com/recursos/personajes-con-emojis.ppsx',
    fileName: 'Personajes-con-Emojis.ppsx',
    icon: IoDice,
  },
  {
    id: 'quien-soy',
    title: '¿Quién Soy?',
    description: 'Juego de adivinanzas sobre personajes y eventos de la Biblia.',
    previewImage: quienSoyPreview,
    fileUrl: 'https://www.feenjuego.com/recursos/quien-soy.ppsx',
    fileName: 'Quien-Soy.ppsx',
    icon: IoDice,
  },
];

export default recursos;

